import type { MentionInterface } from 'modules/community/components/editor/elements/mention/mention.types'

const MENTION_TOKEN_RE = /<@(\d+):([^>]+)>/g

const escapeAttr = (value: string): string =>
  value
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')

export const parseTextWithMentions = (text: string, mentions: MentionInterface[]): string => {
  const byId = new Map((mentions ?? []).map(m => [m.userId, m]))

  return text.replaceAll(MENTION_TOKEN_RE, (_raw, idStr: string, displayName: string) => {
    const userId = Number(idStr)
    const name = escapeAttr(displayName)
    const profileImage = escapeAttr(byId.get(userId)?.profileImage ?? '')
    const dataAvatarUrl = profileImage ? ` data-avatar-url="${profileImage}"` : ''
    return `<span data-type="mention" contenteditable="false"${dataAvatarUrl} data-cy="mention-${name}" data-id="${userId}">@${name}</span>`
  })
}
